module.exports = __webpack_public_path__ + "img/disabled-newCand-f2f-icon.94fb541d.svg";